/**
 * @deprecated
 *      As of 24/09/2024, we use the default browser lazy loading. Talked this over
 *      with Maico, and it makes sense to let this one go. This allows us to more
 *      easily add responsive images, so the time was right. I'm keeping this file
 *      in though, just in case we have an asset or something that uses the supported
 *      classes. In our own templates I'm removing all of them though.
 */
class LazyLoadingHandler {
    constructor(rootMargin, selector) {
        this.selector = selector;

        const observer = new IntersectionObserver(
            (allObserved) => {
                allObserved.forEach((observed) => {
                    if ( ! observed.isIntersecting) {
                        return;
                    }

                    const visibleImage = observed.target;

                    // Trigger image loading by setting
                    // the data-src value to src.
                    visibleImage.src = visibleImage.getAttribute(this.getCleanAttributeName());

                    // Cleanup. We no longer need lazy loading for this image.
                    visibleImage.removeAttribute(this.getCleanAttributeName());
                    observer.unobserve(visibleImage);
                });
            }, {
                // Trigger X pixels before intersecting
                rootMargin: rootMargin,
            }
        );

        document.querySelectorAll(selector).forEach((image) => {
            observer.observe(image);
        });
    }

    getCleanAttributeName() {
        return this.selector.replace('[', '').replace(']', '');
    }
}

document.addEventListener("DOMContentLoaded", () => {
    // The design decision here is to avoid loading pictures
    // for devices not supporting the Intersection Observer.
    if ( ! window.IntersectionObserver) {
        return;
    }

    // Default one, for recipe images
    new LazyLoadingHandler(window.innerWidth > 768 ? '150px 0px 150px 0px' : '200px 0px 200px 0px', "[data-lazy-src]");

    // Tracking pixels
    new LazyLoadingHandler('-10px', "[data-lazy-src-late]");
});